module.exports = __webpack_public_path__ + "img/las-reservas4.675ceea2.png";